import React, {useEffect} from "react";
import {useCartContext} from "../../cart/CartContextProvider/CartContextProvider";
import {getShopId} from "../getShopId";
import window from "../WindowExtended";
import {
  amazonClientId,
  amazonMerchantId,
  amazonPayButtonId,
  amazonPayScriptId,
  amazonScriptSourceUrl,
  isAmazonLoggedIn,
} from "./AmazonPayLibrary";
import {Payments, isoLocales, INTERNAL_ERROR_TYPE} from "./PaymentController";
import {useCustomerContext} from "../../customer/CustomerContextProvider/CustomerContextProvider";
import {ApiError, CheckoutFactory} from "@connox/typescript-library";

const AmazonPayButtonReact: React.FC<{onReturn: () => void; handleError: (err: Error) => void}> = (props) => {
  const {customer} = useCustomerContext();
  const context = useCartContext();

  useEffect(() => {
    const existingButton = document.getElementById("AmazonPayButtonReact");
    const isInitialized = existingButton && !!existingButton.childNodes.length;

    if (!context.isCartVisible || isInitialized || customer.isLoggedIn || getShopId() !== 100001) {
      return;
    }

    const onAmazonLoginReady = () => {
      try {
        window.amazon.Login.setClientId(amazonClientId);
        window.amazon.Login.setUseCookie(true);
      } catch (err) {
        props.handleError(err);
        if (__DEVELOPMENT__) {
          // eslint-disable-next-line no-console
          console.error(err);
        }
      }
    };
    window.onAmazonLoginReady = onAmazonLoginReady;

    const onAmazonPaymentsReady = () => {
      window.OffAmazonPayments.Button(amazonPayButtonId, amazonMerchantId, {
        authorization: () => {
          /* POPUP INITIALIZATION */
          const loginOptions = {
            popup: true,
            scope: "profile payments:widget payments:billing_address payments:shipping_address",
          };
          window.amazon.Login.authorize(loginOptions, (response) => {
            /* AFTER LOGIN */
            if (response.error) {
              const err = new Error(response.error_description);
              err.name = INTERNAL_ERROR_TYPE.AMAZON.auth + err.name;
              props.handleError(err);

              return;
            }
            window.accessToken = response.access_token;
          });
        },
        color: "Gold",
        language: isoLocales[getShopId()],
        onError: (err) => {
          const tempError = new Error(
            `[${INTERNAL_ERROR_TYPE.AMAZON.login}] ${err.getErrorCode()}: ${err.getErrorMessage()}`,
          );
          tempError.name = INTERNAL_ERROR_TYPE.AMAZON.login + tempError.name;
          props.handleError(tempError);
        },
        onSignIn: async (orderReference) => {
          /* AFTER LOGIN */
          window.orderReferenceId = orderReference.getAmazonOrderReferenceId();
          window.isPreauthorizingDone = false;
          window.isBillingAgreementAddressSet = window.isBillingAgreementPaymentSet = false;

          try {
            const checkout = await CheckoutFactory.generateCheckout(getShopId(), context.cart);
            await checkout.put({paymentId: Payments.AmazonPay});
            props.onReturn();
          } catch (e) {
            const tempError = ((e as ApiError).originalError || e) as Error;
            tempError.name = INTERNAL_ERROR_TYPE.AMAZON.signInCatch + tempError.name;
            props.handleError(tempError);
          }
        },
        size: "medium",
        type: "PwA",
      });
    };
    window.onAmazonPaymentsReady = onAmazonPaymentsReady;

    const scriptNode = document.getElementById(amazonPayScriptId);
    if (scriptNode) {
      onAmazonPaymentsReady();

      return;
    }

    const script = document.createElement("script");
    script.id = amazonPayScriptId;
    script.type = "text/javascript";
    script.src = amazonScriptSourceUrl;
    script.async = true;

    document.body.appendChild(script);
  }, []);

  if (!context.isCartVisible || customer.isLoggedIn || getShopId() !== 100001) {
    return null;
  }

  return (
    <div
      id={amazonPayButtonId}
      className="center"
      style={{width: "100%", marginTop: isAmazonLoggedIn() ? ".5rem" : "initial"}}
    >
      {/* to be filled by amazon pay */}
    </div>
  );
};

export default AmazonPayButtonReact;
